/** Normalise assignees: new `assignedUserIds` array or legacy string `assignedTo`. */
export function todoAssigneeIds(todo) {
  if (!todo) return [];
  const ids = todo.assignedUserIds;
  if (Array.isArray(ids) && ids.length) {
    return [...new Set(ids.filter(Boolean))];
  }
  if (todo.assignedTo) return [todo.assignedTo];
  return [];
}
